import AlertBar from './styled';

export default AlertBar;
